/* ==========================================================================
  main.js
========================================================================== */

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 890,
    menu: dropdown_menus[i]
  });
}

/**
 * Init mobile menu
 */
component_mobile_menu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});

/**
 * Init Responsive videos
 */
fitvids();

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    objectFitPolyfill();
    e.target.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Init lightbox
 */
if (document.querySelectorAll('.lightbox').length) {
  try {
    new Tobi({
      // variables from script localization in register-assets.php
      navLabel: [theme_strings.prev, theme_strings.next],
      closeLabel: theme_strings.close,
      loadingIndicatorLabel: theme_strings.loading,
      captionsSelector: 'self',
      captionAttribute: 'data-caption',
      zoom: false,
    });
  } catch (e) {
    console.log(e);
  }
}

/**
 * Sticky header
 */
var header = document.getElementById('masthead');

var headroom  = new Headroom(header, {
  offset: 600,
  tolerance: 0,
  classes: {
    initial: "animated",
    pinned: "slideDown",
    unpinned: "slideUp"
  }
});

 headroom.init();

 var ua = window.navigator.userAgent;
  var ie = ua.indexOf('Trident/');
  if (ie > 0) {
    //console.log('IE detected');
    document.body.classList.add('browser-ie');
  }


if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource !== null && nextSource !== undefined) {
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

/**
 * Before & after
 */
if (document.querySelectorAll('.wp-block-acf-before-after').length) {
  var before_button = document.getElementById("before");
  var after_button = document.getElementById("after");

  var before_media = document.getElementById("before_media");
  var before_content = document.getElementById("before_content");

  var after_media = document.getElementById("after_media");
  var after_content = document.getElementById("after_content");

  after_button.onclick = function() {
    after_media.classList.add("visible");
    after_content.classList.add("visible");
    before_media.classList.add("hidden");
    before_content.classList.add("hidden");
    after_button.classList.add("active");
    before_button.classList.add("not-active");
  };

  before_button.onclick = function() {
    after_media.classList.remove("visible");
    after_content.classList.remove("visible");
    before_media.classList.remove("hidden");
    before_content.classList.remove("hidden");
    after_button.classList.remove("active");
    before_button.classList.remove("not-active");
  };
}

/**
   * Back button
   */
  var back_button = document.getElementById('breadcrumb-back-button');
  if (back_button && document.referrer && document.referrer.length) {
    // onlu use internal URLs
    if (document.referrer.indexOf('skulleimplants.') >= 0) {
      back_button.setAttribute('href', document.referrer);
      back_button.addEventListener('click', function(e) {
        e.preventDefault();
        window.history.back();
      });
    }
  }
